<div *ngIf="!isResetPasswordSuccess">
<form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
  <div class="fwc-container">
    <div class="fwc-row fwc-row-bm fwc-flex-column ">
      <div class="fwc-col-12 sm-12 fwc-input">
        <label for="gibberish">New Password</label>
        <div class="sae-masked-input">
          <input name="gibberish" formControlName="gibberish" id="gibberish" type="password"
            maxlength="20"
            [attr.type]="createMask ? 'password':'text'"
            attr.aria-invalid="{{submitted && form.gibberish.errors ? true : false}}"
            (keydown)="onKey($event)"
            (keyup)="checkPasswordRules();validateFields()"
            required/>
          <span class="sae-icon" [ngClass]="{'sae-icon-blind': createMask, 'sae-icon-eye': !createMask}" role="button" tabindex="0" [attr.aria-label]="createMask ? 'Show password' : 'Hide password'"
          (click)="createMask = !createMask" (keydown.enter)="createMask = !createMask" (keydown.space)="$event.preventDefault(); createMask = !createMask"></span>
        </div>
        @if (submitted && form.gibberish.errors) {
          <span role="alert" class="fwc-inline-icon fwc-icon-delete" aria-hidden="true"
          id="password_error">Please enter a valid Password</span>
        }
        @if (passwordValidateError && submitted && !form.gibberish.hasError('required')) {
          <div>
            <span role="alert" class="fwc-inline-icon fwc-icon-delete" aria-hidden="true">Invalid Password</span>
          </div>
        }
      </div>
      @if (showPasswordRules) {
        <div class="sae-password-rules" role="status" aria-live="polite">
          <ul>
            <li
              [ngClass]="{'rule-met' : ruleLowerMet, 'error-state' : passwordValidateError && submitted && !ruleLowerMet}">
              One lowercase character
            </li>
            <li
              [ngClass]="{'rule-met' : rule8characterMet, 'error-state' : passwordValidateError && submitted && !rule8characterMet}">
              12 characters minimum
            </li>
            <li
              [ngClass]="{'rule-met' : ruleNumberMet, 'error-state' : passwordValidateError && submitted && !ruleNumberMet}">
              One number
            </li>
            <li
              [ngClass]="{'rule-met' : ruleSpecialMet, 'error-state' : passwordValidateError && submitted && !ruleSpecialMet}">
              One special character $ ! &#64; * ? |
            </li>
            <li
              [ngClass]="{'rule-met' : ruleUpperCharMet, 'error-state' : passwordValidateError && submitted && !ruleUpperCharMet}">
              One uppercase character
            </li>
          </ul>
        </div>
      }
    </div>
    <div class="fwc-row fwc-row-bm">
      <div class="fwc-col-12 sm-12 fwc-input">
        <label for="RetypePassword">Retype Password</label>
        <div class="sae-masked-input">
          <input name="RetypePassword" formControlName="retypePassword" id="RetypePassword" type="password"
            maxlength="20"
            [attr.type]="retypeMask ? 'password':'text'"
            (keydown.space)="$event.preventDefault()"
            attr.aria-invalid="{{submitted && form.retypePassword.errors ? true : false}}"
            (keyup)="validateFields()" required/>
          <span class="sae-icon" [ngClass]="{'sae-icon-blind': retypeMask, 'sae-icon-eye': !retypeMask}" role="button" tabindex="0" [attr.aria-label]="retypeMask ? 'Show password' : 'Hide password'"
          (click)="retypeMask = !retypeMask" (keydown.enter)="retypeMask = !retypeMask" (keydown.space)="$event.preventDefault(); retypeMask = !retypeMask"></span>
        </div>
        @if (submitted && form.retypePassword.errors) {
          <span role="alert" class="fwc-inline-icon fwc-icon-delete" aria-hidden="true"
          id="retypePassword_error">Please retype Password</span>
        }
        @if (passwordMatchError && submitted && !form.retypePassword.hasError('required')) {
          <div>
            <span role="alert" class="fwc-inline-icon fwc-icon-delete" aria-hidden="true">The passwords do not match. Please re-enter your new password.</span>
          </div>
        }

      </div>
    </div>
    <!-- <div class="fwc-row fwc-row-bm">
      <button type="submit" class="fwc-btn fwc-btn-primary">Change Password</button>
    </div> -->
    
      <div class="fwc-row fwc-row-bm">
        <div class="fwc-col-12 sm-12 fwc-input">
          <button class="fwc-btn fwc-btn-primary font-elevance-medium">Reset Password</button>
        </div>
    </div>
    </div>

</form>
</div>

<div *ngIf="isResetPasswordSuccess">
  <div class="fwc-container">
    <div class="fwc-row fwc-row-bm fwc-flex-column success-container">
      <div class="lock_icon">
      <svg width="51" height="56" viewBox="0 0 51 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.9167 25.25V14.5833C11.9167 11.0471 13.3214 7.65573 15.8219 5.15524C18.3224 2.65476 21.7138 1.25 25.25 1.25C28.7862 1.25 32.1776 2.65476 34.6781 5.15524C37.1786 7.65573 38.5833 11.0471 38.5833 14.5833V25.25M6.58333 25.25H43.9167C46.8622 25.25 49.25 27.6378 49.25 30.5833V49.25C49.25 52.1955 46.8622 54.5833 43.9167 54.5833H6.58333C3.63781 54.5833 1.25 52.1955 1.25 49.25V30.5833C1.25 27.6378 3.63781 25.25 6.58333 25.25Z"
          stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
       </div>
      <h3 class="paassword_update success-message">Your password has been updated.</h3>
    
    </div>
      <div class="success-container">Your password has been updated.</div>
      <div class="success-container">You'll be redirected in <span class="countdown-text">{{remainingTime}} seconds...</span></div>
  </div>
  <div class="fwc-row fwc-row-bm success-container">
        <div class="fwc-col-12 sm-12">
          <button class="fwc-btn fwc-btn-primary font-elevance-login success-message" (click)="navigateTo('/login')">Go TO Login</button>
        </div>
        </div>
        </div>

@if (displaySpinner) {
  <div class="ant-ui-widget-overlay"></div>
  <div class="ant-ajax-loader">
    <fwc-preloader></fwc-preloader>
  </div>
}
